export default __webpack_public_path__ + "static/img15-642a6b5cd8e8c4b21dbcc1d27f7785e9.png";